"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BottomNavigationAction_1 = __importDefault(require("@material-ui/core/BottomNavigationAction"));
var BottomNavigationAction = function (_a) {
    var children = _a.children, classes = _a.classes, icon = _a.icon, label = _a.label, _b = _a.showLabel, showLabel = _b === void 0 ? false : _b, onChange = _a.onChange, onClick = _a.onClick, selected = _a.selected, id = _a.id;
    return (react_1.default.createElement(BottomNavigationAction_1.default, { classes: classes, icon: icon, label: label, showLabel: showLabel, onChange: onChange, onClick: onClick, selected: selected, id: id }, children));
};
exports.default = BottomNavigationAction;
